import { render, staticRenderFns } from "./NewMailDesignerView.vue?vue&type=template&id=74f50102"
import script from "./NewMailDesignerView.vue?vue&type=script&lang=js"
export * from "./NewMailDesignerView.vue?vue&type=script&lang=js"
import style0 from "./NewMailDesignerView.vue?vue&type=style&index=0&id=74f50102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports